// Simple smooth scroller that takes into account the header for keeping in display
// Note: should only be used with links with anchor references
const SmoothScroll = () => {
  const smoothScrollElm = document.querySelectorAll(".js-smooth-scroll");

  if (!smoothScrollElm) {
    return;
  }

  const smoothScrollTo = (el: HTMLElement) => {
    const nav = document.getElementById('shopify-section-header-mega') as HTMLElement;
    el.focus({ preventScroll: true });

    if (!nav) {
      window.scrollTo({
        top: el.offsetTop,
        behavior: "smooth"
      });

      return;
    }

    window.scrollTo({
      top: el.offsetTop - nav.offsetHeight,
      behavior: "smooth"
    });
  }

  smoothScrollElm.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const link = anchor.getAttribute("href");
      const element = document.getElementById(link?.substring(1) ?? '') as HTMLElement;

      smoothScrollTo(element);
    });
  });
}
export default SmoothScroll;
